import React, { useRef } from "react"
import { useScrollState } from "scrollmonitor-hooks"
import svg from "./svg.module.css"

export const SvgRedline = ({ animate, style }) => {
  const ref = useRef(null)
  const scrollState = useScrollState(ref)
  const animateClass =
    animate && scrollState.isInViewport ? svg.redline_animate : ""
  return (
    <svg
      className={`${svg.redline} ${animateClass}`}
      ref={ref}
      style={style}
      viewBox="0 0 132 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="url(#paint0_linear)"
        className="frame_inner"
        d="M32.5 24.5h99v31h-99z"
      />
      <path className="frame_outer" stroke="#EB5757" d="M47.5 0v24M32 40.5H0" />
      <path
        d="M55.108 13h-2.815v-.419l1.128-1.134c.344-.347.57-.595.68-.744.109-.148.191-.293.246-.433.054-.141.082-.292.082-.455 0-.228-.07-.409-.208-.542-.139-.134-.331-.202-.577-.202-.178 0-.347.03-.507.088a2.026 2.026 0 00-.53.32l-.258-.332c.394-.328.824-.492 1.289-.492.402 0 .718.104.946.31.228.206.343.482.343.83 0 .271-.076.54-.229.806-.152.265-.437.601-.855 1.007l-.938.917v.024h2.203V13zm3.636-.984h-.636V13h-.465v-.984H55.56v-.425l2.033-2.898h.515v2.88h.636v.443zm-1.101-.443V10.15c0-.279.01-.594.029-.946h-.024a4.4 4.4 0 01-.263.466l-1.34 1.904h1.598zM14.947 44.725c0 .273-.077.497-.231.67-.152.174-.37.29-.65.35v.023c.343.042.598.152.764.328.166.176.25.406.25.691 0 .408-.143.723-.426.944-.283.218-.685.328-1.207.328-.226 0-.434-.018-.624-.053a2.089 2.089 0 01-.548-.179v-.463a2.728 2.728 0 001.19.282c.74 0 1.11-.29 1.11-.87 0-.52-.408-.78-1.224-.78h-.422v-.419h.427c.334 0 .6-.073.794-.22a.73.73 0 00.293-.615.603.603 0 00-.216-.492c-.143-.12-.337-.179-.583-.179-.188 0-.365.026-.53.077a2.37 2.37 0 00-.57.28l-.245-.327a2.197 2.197 0 011.333-.445c.416 0 .74.095.97.286.23.19.345.45.345.783zM18.542 48h-2.815v-.419l1.128-1.134c.343-.347.57-.595.68-.744.109-.148.19-.293.245-.434.055-.14.082-.291.082-.454 0-.228-.069-.409-.208-.542-.138-.134-.33-.202-.577-.202-.178 0-.347.03-.507.088a2.026 2.026 0 00-.53.32l-.258-.331c.395-.329.824-.493 1.29-.493.402 0 .717.104.946.31.228.206.342.482.342.83 0 .271-.076.54-.228.806-.152.265-.438.601-.856 1.007l-.937.917v.024h2.203V48z"
        className="frame_text"
        fill="#EB5757"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="47.5"
          y1="24"
          x2="55.5"
          y2="46.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB5757" />
          <stop offset="1" stopColor="#EB5757" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
